import { useGlobal } from "../contexts/GlobalContext";
import Button from "./Button";
import Wa from '../assets/svg/wa.svg?react'

function WorkWithMe() {
  const { t, iUrl, parse, directusGlobals } = useGlobal();
  return (
    <section className="workwithme-section lg:py-16">
      <div className="workwithme-section__container flex flex-col lg:grid lg:grid-cols-2 lg:max-w-content lg:mx-auto lg:px-8 lg:gap-12 lg:items-center">
        {/* Left - Image */}
        <div className="workwithme-section__image-wrapper w-full">
          <img
            src={`${iUrl}${t("sections_data.5.section_cover")}?format=webp`}
            alt="Ceramics workspace collaboration cowork"
            className="workwithme-section__image w-full h-[500px] object-cover  shadow-lg"
          />
        </div>

        {/* Right - Text Content */}
        <div className="workwithme-section__content space-y-6 py-16 lg:py-0 px-8 lg:px-0">
          <h3 className="font-medium workwithme-section__title font-header text-4xl lg:text-5xl text-secondary-700">
            {t("sections_data.5.section_heading")}
          </h3>
          <div className="workwithme-section__paragraph font-body text-lg text-dark-700 leading-relaxed">
            {parse(t("sections_data.5.section_body"))}
          </div>
          <Button
            href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`}
            size="medium"
            data-umami-event="Contact Button - Whatsapp"
            data-umami-event-name="Work with me">
            {t("sections_data.5.section_cta")}
            <Wa className="ml-2 h-5 w-5 fill-current" />
          </Button>
        </div>
      </div>
    </section>
  );
}

export default WorkWithMe;
